import { Link } from 'react-router-dom';

type CatalogEmptyStateProps = {
  language: 'mn' | 'en';
  resolvedBrandLabel: string | null;
};

export function CatalogEmptyState({ language, resolvedBrandLabel }: CatalogEmptyStateProps) {
  return (
    <div
      data-testid="brand-empty-state"
      className="rounded-[15px] border border-[var(--ubuy-border-soft)] bg-white px-8 py-12 text-center shadow-sm"
    >
      <div className="mx-auto flex max-w-xl flex-col items-center">
        <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full border border-[var(--ubuy-border-soft)] bg-[var(--ubuy-accent)] text-xl font-bold text-[var(--ubuy-title)]">
          {resolvedBrandLabel?.slice(0, 1) ?? 'B'}
        </div>
        <h2 className="text-2xl font-bold text-[var(--ubuy-title)]">
          {language === 'mn'
            ? `${resolvedBrandLabel ?? ''} брэндэд одоогоор бараа алга`
            : `No products in ${resolvedBrandLabel ?? 'this brand'} yet`}
        </h2>
        <p className="mt-3 max-w-md text-sm leading-7 text-[var(--ubuy-muted)]">
          {language === 'mn'
            ? 'Өөр брэнд үзэх эсвэл дараа дахин шалгаарай. Энэ collection-д бараа нэмэгдэхэд энд автоматаар харагдана.'
            : 'Browse other brands for now or check back later. Products added to this collection will appear here automatically.'}
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/collections"
            className="inline-flex h-11 items-center justify-center rounded-full bg-[var(--ubuy-title)] px-5 text-sm font-bold text-white transition hover:bg-[var(--ubuy-accent)] hover:text-[var(--ubuy-title)]"
          >
            {language === 'mn' ? 'Бүх брэнд' : 'All brands'}
          </Link>
          <Link
            to="/products"
            className="inline-flex h-11 items-center justify-center rounded-full border border-[var(--ubuy-border-soft)] bg-white px-5 text-sm font-bold text-[var(--ubuy-title)] transition hover:border-[var(--ubuy-accent)]"
          >
            {language === 'mn' ? 'Бүх бараа' : 'All products'}
          </Link>
        </div>
      </div>
    </div>
  );
}
